import { Routes } from '@angular/router';
import { WizardComponent } from '../containers/main/wizard/wizard.component';
import { IntegrateMainComponent } from './main/menu/integrate_menu.component';
import { Testimonial1Component } from './testimonials/testimonial1.component';
import { IntegrationStepNavComponent } from '../shared/navigation/integration_step/integration_step_nav.component';

export const integrateRoutes: Routes = [
  {
     path: '',
     children: [
      { path: '', component: Testimonial1Component, outlet: 'side' },
      { path: '', component: WizardComponent, outlet: 'main', children: [
        { path: '',
          component: IntegrateMainComponent,
          outlet: 'stepContent'
        },
        { path: '',
          component: IntegrationStepNavComponent,
          outlet: 'stepNavigation'
        }
      ]
      }
     ]
   }
];
